// export const BASEURL = "http://localhost:4001/api";
// export const BASEURL = "https://dtest.binarynumbers.io/api"
export const BASEURL = "https://profile.damacproperties.com/api"


// WEBPACK FOOTER //
// ./src/config/index.js